import { forwardRef, Injectable } from '@angular/core'
import { Router } from '@angular/router'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => WhoSubmitService),
  deps: [Router]
})
export abstract class WhoSubmitter {
  public abstract myChild(): void
  public abstract myself(): void
}

@Injectable({
  providedIn: 'root'
})
export class WhoSubmitService implements WhoSubmitter {
  constructor(
    public router: Router
  ) {}

  public myChild(): void {
    this.navigate(['/household', 'child'])
  }

  public myself(): void {
    this.navigate(['/household', 'self'])
  }

  private navigate(path: string[]): void {
    this.router.navigate(path, { queryParamsHandling: 'merge' })
  }
}
